

document.addEventListener("DOMContentLoaded", () => {
	const paymentFormAll = document.querySelectorAll(".payment-form");
	if (paymentFormAll.length > 0) {

		paymentFormAll.forEach(form => {

			const paymentTypeOnce = form.querySelector(".payment-type-once");
			const paymentTypeMonthly = form.querySelector(".payment-type-monthly");

			const otherAmount = form.querySelector(".other-amount");
			const otherAmountInput = form.querySelector(".other-amount-input");

			const paymentAmountRadio = form.querySelectorAll("input[name='amount']");

			let monthlyPay = false;

			paymentTypeMonthly.addEventListener('click', event => {
				paymentTypeMonthly.classList.toggle("active");
				paymentTypeMonthly.disabled = true;
				paymentTypeOnce.disabled = false;
				paymentTypeOnce.classList.toggle("active");
				monthlyPay = true;
			})

			paymentTypeOnce.addEventListener('click', event => {
				paymentTypeMonthly.classList.toggle("active");
				paymentTypeOnce.disabled = true;
				paymentTypeMonthly.disabled = false;
				paymentTypeOnce.classList.toggle("active");
				monthlyPay = false;
			})

			paymentAmountRadio.forEach(element => {
				element.addEventListener('change', event => {
					otherAmountInput.value = '';
					otherAmount.removeAttribute('checked');
				})
			})

			otherAmountInput.addEventListener('input', event => {
				const { value } = otherAmountInput;
				const initialAmount = form.querySelector("input[name='amount']:checked");
				otherAmount.value = value;

				initialAmount.checked = false;
				otherAmount.checked = true;

			})

			form.addEventListener('submit', event => {
				event.preventDefault();

				const formData = new FormData(form);
				const formDataValues = Object.fromEntries(formData.entries());

				const amount = parseFloat(formData.get("amount"));
				const email = formData.get("email");
                console.log(formData);
				let widget = new cp.CloudPayments();

				const dataCloudPayments = formDataValues; // данные дарителя


				const receipt = {
					Items: [ //товарные позиции
						{
							label: 'Добровольное пожертвование в фонд "Помощь пожилым"', //наименование товара
							price: amount, //цена
							quantity: 1.00, //количество
							amount: amount, //сумма
							vat: 0, //ставка НДС
							method: 0, // тег-1214 признак способа расчета - признак способа расчета
							object: 0, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
						}
					],
					taxationSystem: 0, //система налогообложения; необязательный, если у вас одна система налогообложения
					email: email, //e-mail покупателя, если нужно отправить письмо с чеком
					phone: '', //телефон покупателя в любом формате, если нужно отправить сообщение со ссылкой на чек
					isBso: false, //чек является бланком строгой отчетности
					amounts: {
						electronic: amount, // Сумма оплаты электронными деньгами
						advancePayment: 0.00, // Сумма из предоплаты (зачетом аванса) (2 знака после запятой)
						credit: 0.00, // Сумма постоплатой(в кредит) (2 знака после запятой)
						provision: 0.00 // Сумма оплаты встречным предоставлением (сертификаты, др. мат.ценности) (2 знака после запятой)
					}
				};

				if (monthlyPay) {
					dataCloudPayments.CloudPayments = {
						CustomerReceipt: receipt,
						recurrent: { interval: 'Month', period: 1, customerReceipt: receipt, } //один раз в месяц начиная со следующего месяца
					}
				}

				const description = monthlyPay ?
					'Подписка на ежемесячную помощь Благотворительному фонду «Помощь пожилым»' :
					'Единовременная помощь Благотворительному фонду «Помощь пожилым»';

				widget.charge({ //options
					publicId: 'pk_91716afa61e2a9b3e998dfdfb055f', //id из личного кабинета
					description: description, //назначение
					amount: amount, //сумма
					currency: 'RUB', //валюта
					email: email, //email плательщика (необязательно)
					requireEmail: true,
					accountId: email, //идентификатор плательщика (обязательно для создания подписки)
					data: dataCloudPayments,
				},
					function (options) { // success
						import("axios").then(({ default: axios }) => {
							axios({
								method: 'post',
								url: `/api/donation/add/`,
								responseType: 'json',
								data: formData,
							})
						});
						ym(87808995, 'reachGoal', 'donation_success')
					},
					function (reason, options) { // fail

					});
			})

		})
	}
})
